import React from "react";
import "./about.css"; // For About-specific styling

const authors = [
  {
    name: "Claudia Brenner",
    role: "Co-CEO, Catastrophic Wildfire Prevention Consortium at CrowdDoing(CWPC) CEO, Atomic Strategic Design",
    linkedin: "https://www.linkedin.com/in/claudia-brenner/",
    image: "../images/about_images/partners/Claudia.jpg",
  },
  {
    name: "Robert Fishkin",
    role: "CEO & President, CrowDoing Co-CEO, Catastrophic Wildfire Prevention Consortium (CWPC)",
    linkedin: "https://www.linkedin.com/in/bobbyfishkin/",
    image: "../images/about_images/partners/RobertFishkin.jpg",
  },

  //
  // Add other authors here
];

const Authors = () => {
  return (
    <div className="authors-container">
      {authors.map((author, index) => (
        <div className="author" key={index}>
          <div className="author-image">
            <img src={author.image} alt={author.name} />
          </div>
          <div className="author-details">
            <h4>{author.name}</h4>
            <p>{author.role}</p>
            {author.linkedin && (
              <a
                href={author.linkedin}
                target="_blank"
                rel="noopener noreferrer"
                className="linkedin-link"
              >
                <i className="fab fa-linkedin"></i>
              </a>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default Authors;
